// Standalone CDN URL processor for rendered CMS HTML (blog posts,
// HTMLContent). Lives outside the editor barrel on purpose: site components
// import THIS module — importing anything from aldoo-ra/HtmlEditor (index)
// pulls the entire editor (toolbar, plugins, MediaLibrary) into the page
// bundle.
import { url } from "aldoo-ra/CMS/url"

// The server has no DOMParser: the same result by string — the document's
// body (DOMParser hands back body.innerHTML, dropping <html>/<head>), each
// [cdn] element's src (href for a link) set to the CDN URL — so the page the
// server renders and the browser hydrates read the same
const BODY = /<body[^>]*>([\s\S]*)<\/body>/i
const DOCUMENT_PARTS = /<!DOCTYPE[^>]*>|<\/?html[^>]*>|<head[^>]*>[\s\S]*?<\/head>|<\/?body[^>]*>/gi
const TAG = /<([a-zA-Z][\w-]*)(\s[^>]*?)?(\/?)>/g
const CDN_ATTRIBUTE = /\scdn\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i

const escapeAttribute = (value) => String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;")

const updateCDNUrlsByString = (htmlString) => {
  const body = htmlString.match(BODY)
  const html = body ? body[1] : htmlString.replace(DOCUMENT_PARTS, "")
  return html.replace(TAG, (tag, name, attributes = "", selfClosing) => {
    const cdn = attributes.match(CDN_ATTRIBUTE)
    const cdnValue = cdn && (cdn[1] ?? cdn[2] ?? cdn[3])
    if (!cdnValue) return tag
    const target = name.toLowerCase() === "a" ? "href" : "src"
    const kept = attributes.replace(new RegExp(`\\s${target}\\s*=\\s*(?:"[^"]*"|'[^']*'|[^\\s>]+)`, "i"), "")
    return `<${name}${kept} ${target}="${escapeAttribute(url(cdnValue))}"${selfClosing}>`
  })
}

export const updateCDNUrls = (htmlString) => {
  if (!htmlString || typeof htmlString !== "string") return ""
  if (typeof DOMParser === "undefined") return updateCDNUrlsByString(htmlString)

  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, "text/html")
  const elements = doc.querySelectorAll("[cdn]")

  elements.forEach((element) => {
    const cdnValue = element.getAttribute("cdn")
    if (cdnValue) {
      const fullUrl = url(cdnValue)
      if (element.tagName.toLowerCase() === "a") {
        element.setAttribute("href", fullUrl)
      } else {
        element.setAttribute("src", fullUrl)
      }
    }
  })

  return doc.body.innerHTML
}
